import {makeStyles} from "@material-ui/core";
import { red } from "@material-ui/core/colors";

export default function useStyles() {
    return makeStyles((theme) => ({
        pdfView: {
            minHeight: "65vh"
        },
        closeButton: {
            padding: "1px", 
            float: "right"
        },
    }));
};
